import { isIOS, getPlatform } from './platform';

let provider = null;

const PaymentService = {
  async initialize() {
    if (isIOS()) {
      const { ApplePaymentProvider } = await import('./payment-apple');
      provider = ApplePaymentProvider;
    } else {
      const { StripePaymentProvider } = await import('./payment-stripe');
      provider = StripePaymentProvider;
    }
    return provider.initialize();
  },

  async getProducts() {
    if (!provider) await this.initialize();
    return provider.getProducts();
  },

  async purchase(productId) {
    if (!provider) await this.initialize();
    return provider.purchase(productId);
  },

  async manageSubscription() {
    if (!provider) await this.initialize();
    return provider.manageSubscription();
  },

  async restorePurchases() {
    if (!provider) await this.initialize();
    return provider.restorePurchases();
  },

  async getEntitlements() {
    if (!provider) await this.initialize();
    return provider.getEntitlements();
  },

  getPlatform() {
    return getPlatform();
  },
};

export default PaymentService;
